export default __webpack_public_path__ + "static/media/doctor-2.b2cda34c.jpg";